import React, { useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from './Box';
import Row from './Row';
import CartImage from '../assets/icons/cart.png';
import HeartImage from '../assets/icons/heart.png';
import XrplImage from '../assets/icons/xrpl.png';
import RefreshImage from '../assets/icons/refresh.png';
import { faCircleCheck, faClose, faInfoCircle, faSpinner, faWarning } from '@fortawesome/free-solid-svg-icons';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import './ShoppingCart.css';
import { formatter } from '../utils/currencyFormatter';
import { Divider, Modal, ModalClose, ModalDialog } from '@mui/joy';
import { useAppContext } from '../context/AppContext';


const ShoppingCart = ({ cart, buttonText, buttonDisabled = false, onRemoveFromCart, onButtonClick, isCartLoading = false, setIsCartLoading = () => {} }) => {
  const { tags = [] } = cart;
  const { popularTagIsPresent, setPopularTagIsPresent } = useAppContext();
  const [showFeeWarning, setShowFeeWarning] = useState(false);
  const [showWaiverModal, setShowWaiverModal] = useState(false);
  const [showEarlyBirdModal, setShowEarlyBirdModal] = useState(false);
  const [disableButton, setDisableButton] = useState(buttonDisabled);
  const defaultEarlyBirdDiscount = 0.9; // 90% off
  const [grandTotal, setGrandTotal] = useState(0);
  const [renewalRate, setRenewalRate] = useState(0.1); // 10%
  const [renewalFee, setRenewalFee] = useState(0);
  const [renewalFeeWaiver, setRenewalFeeWaiver] = useState(0);
  const [subtotal, setSubtotal] = useState(0);

  const forSurePopularTagPresentCopy = 'Because this tag(s) corresponds to a well-known entity, it requires verification before you can use it. You can still buy it, however, if you cannot complete verification, you may be required to sell it at fair market value to the real entity who can.';

  useEffect(() => {
    setPopularTagIsPresent(!!tags.find(tag => tag.isPopular));
  }, [tags, setPopularTagIsPresent]);

  useEffect(() => {
    if (cart.tags && cart.total) {
      setRenewalFee(cart.total * renewalRate);
      setSubtotal(cart.total + cart.fees);
      setRenewalFeeWaiver(cart.total * renewalRate);

      let totalDiscounts = 0;
      if (cart.discounts) {
        cart.discounts.forEach(discount => {
          const d = calculateDiscount(discount, cart.total);
          totalDiscounts += d.amount;
        });
      }
      setGrandTotal(Math.max(subtotal - totalDiscounts, 0));
      setIsCartLoading(false);
    }
  }, [cart.tags, cart.total, cart.discounts, cart.fees, renewalFeeWaiver, subtotal, setIsCartLoading, renewalRate]);

  useEffect(() => {
    setDisableButton(!!popularTagIsPresent);
  }, [popularTagIsPresent]);

  if (isCartLoading) {
    return (
      <Box
        backgroundColor={'#FAFAFA'}
        style={{
          maxWidth: 500,
        }}
      >
        <Row justifyContent="space-between" alignItems="center">
          <span style={{
            color: '#A7A7A7',
            fontWeight: 'bold'
          }}>Adding item to cart...</span>
          <FontAwesomeIcon icon={faSpinner} spin={true} />
        </Row>
      </Box>
    );
  }

  if (tags.length === 0) {
    return (
      <Box
        backgroundColor={'#FAFAFA'}
        style={{
          maxWidth: 500,
        }}
      >
        <Row justifyContent="space-between" alignItems="center">
          <span style={{
            color: '#A7A7A7',
            fontWeight: 'bold'
          }}>Your cart is empty</span>
          <img src={CartImage} width={54} />
        </Row>
      </Box>
    );
  }

  return (
    <Typography>
      <div>
        <Box backgroundColor={'#FAFAFA'}>
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              border: '1px solid #BDBDBD',
              marginBottom: '20px',
            }}
          >
            {tags.map(tag =>
              <div
                key={tag.text}
                className="cart-item"
              >
                <Row justifyContent="space-between" alignItems="center">
                  <div>
                    {tag.isPopular === null &&
                      <FontAwesomeIcon icon={faSpinner} spin style={{ paddingRight: 5 }} title="Checking popularity" />}
                    {tag.isPopular === false &&
                      <FontAwesomeIcon icon={faCircleCheck} color={'var(--and-palette-primary-solidBg, #50BFB4)'} style={{ paddingRight: 5 }} title="Available &tag" />}
                    {tag.isPopular &&
                      <FontAwesomeIcon icon={faWarning} color={'orange'} style={{ paddingRight: 5 }} title="Popular &tag" />}
                    <span style={{ color: '#545454' }}>&{tag.text}</span>
                  </div>
                  <Row alignItems="center">
                    <strong style={{ color: '#545454' }}>{tag.price}</strong>
                    <FontAwesomeIcon
                      icon={faClose}
                      className="clickable"
                      onClick={() => onRemoveFromCart(tag)}
                    />
                  </Row>
                </Row>
              </div>
            )}
          </div>
          <Row justifyContent="space-between" alignItems="center"
            style={{
              marginBottom: 20,
            }}
          >
            <Typography level="body2">Annual Renewal Fee</Typography>
            <Typography level="body2">
              <span style={{ paddingRight: 5 }}>
                <FontAwesomeIcon icon={faInfoCircle} className="cart-info" focusable onClick={() => setShowFeeWarning(true)} />
              </span>
              {/* <span style={{ paddingRight: 5 }}>
                <strong style={{ color: "lightgrey", textDecoration: "line-through" }}>{formatter.format(cart.fees)}</strong>
              </span> */}
              <strong style={{ color: '545454' }}>+{formatter.format(renewalFee)}</strong>
            </Typography>
          </Row>
          {/* <Row
            justifyContent="space-between"
            alignItems="center"
            style={{
              marginBottom: 20,
            }}
          >
            <Typography level="body2">Subtotal</Typography>
            <Typography level="body2">
              <strong style={{ color: "545454" }}>{formatter.format(subtotal)}</strong>
            </Typography>
          </Row> */}
          {/* <Row flexDirection="column"> */}
          <Typography level="h6" style={{ color: '#545454' }}>
            Discounts
          </Typography>
          {/* <Row justifyContent="space-between" alignItems="center">
            <Typography level="body2">Renewal Fee Waiver</Typography>
            <Typography level="body2">
              <span style={{ paddingRight: 5 }}>
                <FontAwesomeIcon icon={faInfoCircle} className="cart-info" focusable onClick={() => setShowWaiverModal(true)} />
              </span>
              <span style={{ paddingRight: 5 }}>
                  <strong style={{ color: "lightgrey", textDecoration: "line-through" }}>{formatter.format(cart.fees)}</strong>
                </span>
              <strong style={{ color: "green" }}>{formatter.format(renewalFeeWaiver)}</strong>
            </Typography>
          </Row> */}
          {cart.discounts && cart.discounts.map(discount => {
            const d = calculateDiscount(discount, cart.total);
            return (
              <Row key={discount.amount} justifyContent="space-between" alignItems="center"
              >
                <div>
                  {d.amount && (
                    <>
                      <Typography level="body2">{discount.name}</Typography>
                      {d.amountString && <Typography level="body4" sx={{ paddingLeft: 1, color: 'gray', fontWeight: '900' }}>({d.amountString} OFF)</Typography>}
                    </>
                  )
                  }
                </div>
                <Typography level="body2">
                  {/* <span style={{ paddingRight: 5 }}>
                  <FontAwesomeIcon icon={faInfoCircle} className="cart-info" focusable onClick={() => setShowEarlyBirdModal(true)} />
                </span> */}
                  {/* <span style={{ paddingRight: 5 }}>
                <strong style={{ color: "lightgrey", textDecoration: "line-through" }}>{formatter.format(cart.fees)}</strong>
              </span> */}
                  <strong style={{ color: 'green' }}>-{formatter.format(d.amount)}</strong>
                </Typography>
                {/* </Row> */}
              </Row>
            );
          }
          )
          }

          <Divider sx={{ marginTop: 2 }} />
          {/* <Row justifyContent="space-between" alignItems="center"
            style={{
              marginBottom: 20, marginTop: 15
            }}>
            <Typography level="h6">Subtotal</Typography>
            <Typography level="h6">{formatter.format(cart.total + cart.fees)}</Typography>
          </Row>
          <Row justifyContent="space-between" alignItems="center"
            style={{
              marginBottom: 20, marginTop: 15
            }}>
            <Typography level="h6">Discounts Applied</Typography>
            <Typography level="h6">{formatter.format((cart.total * .9) + (cart.fees))}</Typography>
          </Row>
          <Divider /> */}

          <Row justifyContent="space-between" alignItems="center"
            style={{
              marginBottom: 20, marginTop: 15
            }}>
            <strong style={{ color: '#545454' }}>Total</strong>
            <strong style={{ color: '#545454' }}>{formatter.format(grandTotal)}</strong>
          </Row>
          {(popularTagIsPresent) &&
            <Row flexDirection="column" gap={0} style={{ padding: 20, backgroundColor: 'orange', borderRadius: 10, color: 'white', fontSize: '1rem' }}>
              {popularTagIsPresent &&
                <div>
                  <FontAwesomeIcon icon={faWarning} color={'white'} fontSize={20} style={{ paddingRight: 10 }} />
                  <Typography level="h5" style={{ color: 'white' }}>Verification Required
                  </Typography>
                </div>
              }
              <p>
                {popularTagIsPresent && forSurePopularTagPresentCopy}
              </p>
            </Row>}
          <Row style={{ marginTop: 10 }} flexDirection="column" alignItems="center">
            {buttonText && <Button
              onClick={onButtonClick}
              disabled={disableButton}
              fullWidth
            >{buttonText}</Button>}
            {popularTagIsPresent &&
              <Typography level="body2" color="danger" sx={{ textAlign: 'center' }}>&tags that require verification are not available for purchase during Private Beta testing.</Typography>
            }
          </Row>
        </Box>
        <Row alignItems="center" gap={20} style={{ padding: 10 }}>
          <img src={HeartImage} width={35} />
          Every purchase helps provide  free identities for all.
        </Row>
        <Row alignItems="center" gap={20} style={{ padding: 10 }}>
          <img src={XrplImage} width={35} />
          Each &tag is backed by an NFT on XRPL, so you truly own it.
        </Row>
        <Row alignItems="center" gap={20} style={{ padding: 10 }}>
          <img src={RefreshImage} width={35} />
          Use your &tag and enjoy frees. See other fees for reselling or holding multiple &tags.
        </Row>
        <Row alignItems="center" gap={20} style={{ padding: 10 }}>
          <img src="https://a300.stripecdn.com/climate-statics-srv/assets/img/climate_logo-7e2de8ca7243c666c6b0.svg" width={35} />
          At The & Company, we contribute 1% of our revenue to carbon removal
        </Row>
      </div>
      <Modal open={showFeeWarning}>
        <ModalDialog
          color="neutral"
          layout="center"
          size="md"
          variant="plain"
        >
          <ModalClose onClick={() => setShowFeeWarning(false)} />
          <Typography level="h4" textColor="#000">Annual Renewal Fees</Typography>
          <p>
            There will be no Annual Renewal Fees <br />
            a) for up to 3 premium &tags you're using personally, or <br />
            b) before 2024 Jun 30.
          </p>
          <p>
            After that, we plan to impose Annual Renewal Fees (Fees) for holding numerous &tags that are not being used. Our intent is to ensure equitable distribution of &tags, such that a small number of people can't hoard all the best ones. You'll be notified before this happens, and you'll be able to choose whether to put your excess &tags (beyond the ones you're using personally) up for sale at fair market value (FMV) or to hold them and pay the Fees, which will be a percentage of the FMV of the &tag.
          </p>
          <p>
            To use an &tag, open your profile in the mobile app and tap your current &tag. You'll be able to choose which ones to use, thus actively linking them to your & identity.
          </p>
        </ModalDialog>
      </Modal>
      <Modal open={showWaiverModal}>
        <ModalDialog
          color="neutral"
          layout="center"
          size="md"
          variant="plain"
        >
          <ModalClose onClick={() => setShowWaiverModal(false)} />
          <Typography level="h4" textColor="#000">Annual Renewal Fee Waiver</Typography>
          <p>
            We're dedicated to promoting a fair and inclusive environment for everyone. As a token of appreciation for your active engagement and staying within the limit, we're waiving the Annual Renewal Fees for your &tags. This ensures that you can continue enjoying your favorite &tags without incurring any extra costs. We're committed to preventing hoarding and making sure the best &tags are accessible to our thriving community.
          </p>
        </ModalDialog>
      </Modal>
      <Modal open={showEarlyBirdModal}>
        <ModalDialog
          color="neutral"
          layout="center"
          size="md"
          variant="plain"
        >
          <ModalClose onClick={() => setShowEarlyBirdModal(false)} />
          <Typography level="h4" textColor="#000">Early Bird Discount</Typography>
          <p>
            As a thank you for your valuable feedback, we're offering an exclusive early bird discount for our beta testers. Join our community of pioneers and, together, let's move the world toward joy.
          </p>
        </ModalDialog>
      </Modal>
    </Typography>
  );
};

function calculateDiscount(discount, subtotal) {
  if (!discount) {
    return { amount: 0, amountString: '' };
  }

  let amount = 0;
  let amountString = '';
  if (discount.dollarOff) {
    amount = subtotal - (subtotal - discount.dollarOff);
    // amountString = `${formatter.format(discount.dollarOff)}`;
  } else if (discount.percentOff) {
    amount = subtotal * (discount.percentOff / 100);
    amountString = `${discount.percentOff}%`;
  }

  return { amount, amountString };
}

export default ShoppingCart;